<template>
  <div
    class="table-column"
    :class="{ 'is-leaf': !hasSubColumns }">
    <div
      class="table-column-header"
      :class="{
        'sortable-header': isSortable,
        'dimension-group': column.column_type === 'MEASURE_GROUP',
      }"
      :style="{
        height: (height + headerMargin) + 'px',
        paddingTop: headerMargin + 'px',
        alignItems: headerMargin ? 'flex-end' : null,
      }"
      @click="toggleSort">
      <b-tooltip
        type="is-dark"
        position="is-right"
        multilined
        class="table-header-tooltip"
        content-class="custom-tooltip-content">
        <template #content>
          {{ column.label }}
        </template>
        <span class="column-label">{{ column.label }}</span>
      </b-tooltip>
      <i
        class="sort-icon material-icons"
        :class="{ sorted: isSorted }">
        {{ !isSortAscending ? "arrow_drop_down" : "arrow_drop_up" }}
      </i>
    </div>

    <div
      v-if="hasSubColumns"
      class="table-column-sub-columns">
      <table-column
        v-for="subColumn in column.sub_columns"
        :key="subColumn.id"
        :current-depth="currentDepth + 1"
        :column="subColumn"
        :rows="rows"
        :table-sort="tableSort"
        @update:table-sort="$emit('update:table-sort', $event)" />
    </div>
    <template v-if="!hasSubColumns">
      <template v-for="cell in rows[column.row_idx]">
        <TableCell
          :key="cell.id"
          :cell-data="cell"
          :column="column" />
      </template>
    </template>
  </div>
</template>

<script>
  import TableCell from './TableCell.vue'

  export default {
    name: 'TableColumn',
    components: {
      TableCell,
    },
    inject: ['getMaxDepth', ],
    props: {
      tableSort: {
        type: Object,
        required: true,
      },
      column: {
        type: Object,
        required: true,
      },
      rows: {
        type: Object,
        required: true,
      },
      currentDepth: {
        type: Number,
        required: true,
      },
    },
    data () {
      return {
        headerCellHeight: 40,
      }
    },

    computed: {
      hasSubColumns () {
        return this.column.sub_columns.length > 0
      },

      height () {
        if (!this.hasSubColumns) {
          return this.headerCellHeight
        }
        return (
          this.headerCellHeight *
          (this.getMaxDepth() - this.column.depth - this.currentDepth + 1)
        )
      },

      headerMargin () {
        if (!this.hasSubColumns) {
          return this.headerCellHeight * (this.getMaxDepth() - this.currentDepth)
        }
        return 0
      },

      isSortable () {
        return !this.hasSubColumns
      },

      isSorted () {
        return this.isSortable && this.tableSort.rowIdx == this.column.row_idx
      },

      isSortAscending () {
        return this.tableSort.ascending
      },
    },

    mounted () {},
    methods: {
      toggleSort () {
        if (this.isSortable) {
          if (!this.isSorted) {
            this.$emit('update:table-sort', {
              rowIdx: this.column.row_idx,
              ascending: false,
            })
          } else {
            this.$emit('update:table-sort', {
              rowIdx: this.column.row_idx,
              ascending: !this.tableSort.ascending,
            })
          }
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
.table-column {
  overflow: visible;

  &.is-leaf {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
  }
}

.table-column-header {
  min-width: 200px;
  height: 50px;
  background-color: white;
  border-right: 1px solid #e9e9ea;
  border-bottom: 1px solid #e9e9ea;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: visible;

  &.dimension-group {
    text-align: left;
    font-weight: 600;
  }

  .table-header-tooltip {
    max-width: 100%;
    min-width: 0;
    flex: 0 1 auto;
    display: flex;
  }

  .column-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
    min-width: 0;
    flex: 0 1 auto;
  }

  .sort-icon {
    font-size: 18px;
    text-align: right;
    margin-left: auto;
    display: none;
    flex-shrink: 0;
    &.sorted{
      display: block !important;
      color: #994095;
    }

  }

}

.table-column-sub-columns {
  display: flex;
}

.sortable-header {
  cursor: pointer;
  &:hover {
    background-color: #f5f5f5;
    .sort-icon {
      display: block !important;
    }
  }
}
</style>
